import TeamsLogo from '../components/TeamsLogo';

const IndexPage = () => {

  return (
    <>
      <style>{`
        :root {
          --brand-purple: #6264a7;
          --brand-purple-dk: #3d3f8e;
          --brand-purple-lt: #bdbde6;
          --brand-bg: #f5f5f5;
          --card-bg: #ffffff;
          --text: #252423;
          --text-mid: #616161;
          --text-light: #9a9a9a;
          --border: #e0e0e0;
          --font: "Segoe UI", -apple-system, BlinkMacSystemFont, sans-serif;
        }
        *, *::before, *::after {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }
        html, body, #root {
          min-height: 100vh;
          width: 100%;
          margin: 0;
          padding: 0;
          font-family: var(--font);
          font-size: 14px;
          color: var(--text);
          background: var(--brand-bg);
          -webkit-font-smoothing: antialiased;
          user-select: none;
          -webkit-user-select: none;
        }
        button {
          font-family: var(--font);
          cursor: pointer;
          border: none;
          background: none;
        }
        a {
          color: var(--brand-purple);
          text-decoration: none;
        }
        a:hover {
          text-decoration: underline;
        }
        .container {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
        }
        .header {
          height: 48px;
          background: #464775;
          display: flex;
          align-items: center;
          padding: 0 16px;
          gap: 12px;
          box-shadow: 0 1px 2px rgba(0,0,0,0.1);
        }
        .header-title {
          color: white;
          font-size: 14px;
          font-weight: 600;
        }
        .main-content {
          flex: 1;
          display: flex;
        }
        .sidebar {
          width: 64px;
          background: #464775;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding-top: 16px;
          gap: 4px;
        }
        .sidebar-btn {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 12px 0;
          color: rgba(255,255,255,0.7);
          transition: color 0.15s, background 0.15s;
        }
        .sidebar-btn:hover {
          color: white;
          background: rgba(255,255,255,0.1);
        }
        .sidebar-btn span {
          font-size: 10px;
          margin-top: 4px;
        }
        .content-area {
          flex: 1;
          display: flex;
          flex-direction: column;
        }
        .content-header {
          height: 56px;
          background: white;
          border-bottom: 1px solid var(--border);
          display: flex;
          align-items: center;
          padding: 0 24px;
          gap: 16px;
        }
        .content-header h1 {
          font-size: 18px;
          font-weight: 600;
          color: var(--text);
        }
        .content-body {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 32px;
        }
        .welcome-card {
          width: 100%;
          max-width: 672px;
          opacity: 1;
          transform: none;
          animation: fadeUp 0.4s ease both;
        }
        @keyframes fadeUp {
          from {
            opacity: 0;
            transform: translateY(16px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .welcome-title {
          font-size: 24px;
          font-weight: 700;
          color: var(--text);
          margin-bottom: 4px;
        }
        .welcome-subtitle {
          font-size: 14px;
          color: var(--text-mid);
          margin-bottom: 32px;
        }
        .feature-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 16px;
        }
        .feature-card {
          background: white;
          border: 1px solid var(--border);
          border-radius: 12px;
          padding: 24px;
          box-shadow: 0 1px 3px rgba(0,0,0,0.08);
          transition: box-shadow 0.2s;
        }
        .feature-card:hover {
          box-shadow: 0 4px 12px rgba(0,0,0,0.1);
        }
        .feature-icon {
          width: 64px;
          height: 64px;
          margin-bottom: 16px;
          border-radius: 8px;
          background: #f0f0f0;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
        }
        .feature-title {
          font-weight: 600;
          color: var(--text);
          margin-bottom: 8px;
        }
        .feature-desc {
          font-size: 14px;
          color: var(--text-mid);
          margin-bottom: 16px;
        }
        .feature-link {
          font-size: 14px;
          font-weight: 600;
          color: var(--brand-purple);
          transition: color 0.15s;
        }
        .feature-link:hover {
          color: var(--brand-purple-dk);
          text-decoration: none;
        }
        .mobile-prompt {
          margin-top: 24px;
          font-size: 14px;
          color: var(--text-mid);
          text-align: center;
        }
        .mobile-prompt span {
          color: var(--brand-purple);
          font-weight: 500;
        }
      `}</style>

      <div className="container">
        <header className="header">
          <TeamsLogo size={20} />
          <span className="header-title">Microsoft Teams</span>
        </header>

        <main className="main-content">
          <nav className="sidebar">
            <button className="sidebar-btn">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2a10 10 0 1 1-4.64 18.86l-4.3 1.12a.85.85 0 0 1-1.03-1.04l1.11-4.29A10 10 0 0 1 12 2Zm1.25 11h-4.6a.75.75 0 0 0 0 1.5H13.35a.75.75 0 0 0 0-1.5h-.1Zm2-3.5h-6.6a.75.75 0 0 0 0 1.5H15.35a.75.75 0 0 0 0-1.5h-.1Z" fill="currentColor" />
              </svg>
              <span>Chat</span>
            </button>
            <button className="sidebar-btn">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.25 5A3.25 3.25 0 0 0 2 8.25v7.5C2 17.55 3.46 19 5.25 19h7.5c1.8 0 3.25-1.46 3.25-3.25v-.31l3.26 2.25c1.16.8 2.74-.03 2.74-1.44v-8.5a1.75 1.75 0 0 0-2.74-1.44L16 8.56v-.31C16 6.45 14.54 5 12.75 5h-7.5Z" fill="currentColor" />
              </svg>
              <span>Meet</span>
            </button>
            <button className="sidebar-btn">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.5 2A2.5 2.5 0 0 0 4 4.5v15A2.5 2.5 0 0 0 6.5 22h12.75a.75.75 0 0 0 0-1.5H6.5a1 1 0 0 1-1-1h13.75c.41 0 .75-.34.75-.75V4.5A2.5 2.5 0 0 0 17.5 2h-11Zm-1 16V4.5a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1V18h-13ZM14 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1.5 4.5c0 1.25-1 2.5-3.5 2.5s-3.5-1.25-3.5-2.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z" fill="currentColor" />
              </svg>
              <span>People</span>
            </button>
          </nav>

          <div className="content-area">
            <div className="content-header">
              <h1>Chat</h1>
            </div>
            <div className="content-body">
              <div className="welcome-card">
                <h2 className="welcome-title">Welcome to Teams</h2>
                <p className="welcome-subtitle">Here are some things to get you going.</p>
                
                <div className="feature-grid">
                  <div className="feature-card">
                    <div className="feature-icon">
                      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <defs>
                          <linearGradient id="chatGrad" x1="2" y1="2" x2="22" y2="22" gradientUnits="userSpaceOnUse">
                            <stop stopColor="#6264A7" />
                            <stop offset="1" stopColor="#7B83EB" />
                          </linearGradient>
                        </defs>
                        <path d="M12 2a10 10 0 1 1-4.64 18.86l-4.3 1.12a.85.85 0 0 1-1.03-1.04l1.11-4.29A10 10 0 0 1 12 2Zm1.25 11h-4.6a.75.75 0 0 0 0 1.5H13.35a.75.75 0 0 0 0-1.5h-.1Zm2-3.5h-6.6a.75.75 0 0 0 0 1.5H15.35a.75.75 0 0 0 0-1.5h-.1Z" fill="url(#chatGrad)" />
                      </svg>
                    </div>
                    <h3 className="feature-title">Send instant messages</h3>
                    <p className="feature-desc">Share files, and more over chat.</p>
                    <a href="#" className="feature-link">New chat</a>
                  </div>

                  <div className="feature-card">
                    <div className="feature-icon">
                      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <defs>
                          <linearGradient id="meetGrad" x1="2" y1="5" x2="22" y2="19" gradientUnits="userSpaceOnUse">
                            <stop stopColor="#6264A7" />
                            <stop offset="1" stopColor="#7B83EB" />
                          </linearGradient>
                        </defs>
                        <path d="M5.25 5A3.25 3.25 0 0 0 2 8.25v7.5C2 17.55 3.46 19 5.25 19h7.5c1.8 0 3.25-1.46 3.25-3.25v-.31l3.26 2.25c1.16.8 2.74-.03 2.74-1.44v-8.5a1.75 1.75 0 0 0-2.74-1.44L16 8.56v-.31C16 6.45 14.54 5 12.75 5h-7.5Z" fill="url(#meetGrad)" />
                      </svg>
                    </div>
                    <h3 className="feature-title">Skip the calendar</h3>
                    <p className="feature-desc">Create an instant meeting with just a click.</p>
                    <a href="#" className="feature-link">Meet now</a>
                  </div>
                </div>

                <p className="mobile-prompt">
                  Stay connected across all your devices by downloading the{' '}
                  <span>Teams mobile app</span>.
                </p>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default IndexPage;
